import { getAdoptableSliderWidgetConfig } from './ShopAll/AdoptableSlider/widgetConfig';
import { getCommissionSliderWidgetConfig } from './ShopAll/CommissionSlider/widgetConfig';
import { getPremiumContentSliderWidgetConfig } from './ShopAll/PremiumContentSlider/widgetConfig';
import { getPremiumFolderSliderWidgetConfig } from './ShopAll/PremiumFolderSlider/widgetConfig';
import getCoverDeviationWidgetConfig from '../../UserWidgets.deviation_gruser/CoverDeviation/widgetConfig';

export const getShopWidgetConfigs = ({ t, dispatch }) => ({
  coverDeviation: getCoverDeviationWidgetConfig({ t, dispatch }),
  commissions: getCommissionSliderWidgetConfig({ t, dispatch }),
  adoptables: getAdoptableSliderWidgetConfig({ t, dispatch }),
  premiumContent: getPremiumContentSliderWidgetConfig({ t, dispatch }),
  premiumFolders: getPremiumFolderSliderWidgetConfig({ t, dispatch }),
});
